<template>
  <v-card class="ml-2 mr-2" height="100%">
    <h2 class="text-xs-center">{{$t('dashboard.interaction.title')}}</h2>
    <v-layout column @click="showInterventions">
       <div class="text-xs-center">
        <v-icon class="real-big-icon">mdi-account-multiple</v-icon>
      </div>


      <v-container fluid grid-list-md style="font-size: 20px;">
        <v-layout wrap row class="pointer mt-2 mb-5">
          <v-flex xs4 class="text-xs-right text-bold">
            {{counts.isNew | blank}}
          </v-flex>
          <v-flex xs7 offset-xs1 >
            {{$t('dashboard.interaction.new')}}
          </v-flex>
          <v-flex xs4  class="text-xs-right text-bold">
           {{counts.inProgress | blank}}
          </v-flex>
          <v-flex xs7 offset-xs1 >
            {{$t('dashboard.interaction.in_progress')}}
          </v-flex>
          <v-flex xs4  class="text-xs-right text-bold">
            {{counts.delayed | blank}}
          </v-flex>
          <v-flex xs7 offset-xs1 >
            {{$t('dashboard.interaction.delayed')}}
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
  </v-card>
</template>

<script>
import {GET_INTERVENTION_COUNT, GET_INTERVENTION_INTERACTIONS} from '../../store/action-types'
import { mapState } from 'vuex'

export default {
  name: 'dashboard-interactions',
  methods: {
    showInterventions () {
      this.$store.dispatch(GET_INTERVENTION_INTERACTIONS)
      this.$router.push({name: 'Interactions'})
    }
  },
  computed: {
    ...mapState({
      counts: state => state.intervention.counts
    })
  },
  filters: {
    blank (value) {
      if (value === undefined) {
        return '0'
      }
      return value
    }
  },
  mounted () {
    this.$store.dispatch(GET_INTERVENTION_COUNT)
  }
}
</script>

<style scoped>
.real-big-icon {
  font-size: 112px;
}
.interaction-count {
  font-size: 20px;
  margin-bottom: 60px;
  margin-top: 8px;
  cursor: pointer;
}
.text-bold {
  font-weight: bolder;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardInteractions.vue